module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "like-btn",
    class: _vm.likeClass,
    attrs: {
      "title": "좋아요 버튼",
      "disabled": _vm.isDisable
    },
    on: {
      "click": _vm.addLike
    }
  }, [_c('i', {
    staticClass: "fa fa-heart liked-heart"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-heart-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "alt-text"
  }, [_vm._v(_vm._s(_vm.altText))]), _vm._v(" "), _c('span', {
    staticClass: "like-text"
  }, [_vm._v(_vm._s(_vm.count))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-503c08a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/portal/LikeBtn.vue
// module id = 1394
// module chunks = 6